module.exports = __webpack_public_path__ + "static/media/encryption.1efaeb6c.svg";